import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { Box } from "@mui/material";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Divider from "@mui/material/Divider";
import FormControlLabel from "@mui/material/FormControlLabel";
import Typography from "@mui/material/Typography";
import { styled as styling } from "@mui/material/styles";
import Color from "../../../assets/colors";
import SGFlag from "../../../public/images/SG.svg";

export const DialogStyled = styling(Dialog)({
  "& .MuiDialog-paper": {
    maxWidth: "524px",
    borderRadius: "8px",
  },
});

export const DialogTitleStyled = styling(Typography)({
  fontSize: "1.25rem",
  fontWeight: "700",
  lineHeight: "1.5rem",

  "@media (max-width: 640px)": {
    fontSize: "1rem",
  },
});

export const BoxContainer = styling(Box)({
  display: "flex",
});

export const DividerStyled = styling(Divider)({});

export const DialogContentStyled = styling(DialogContent)({
  paddingBlock: "16px 12px",
});

export const DialogMessage = styling(Typography)({
  fontSize: "1rem",
  color: "rgba(0, 0, 0, 0.87)",
});

export const DialogActionsStyled = styling(DialogActions)({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  gap: "16px",
  paddingInline: "24px",
  paddingBottom: "24px",
});

export const PrimaryButton = styling(Button)({
  textTransform: "none",
  backgroundColor: Color.hiredlyPurple,
  color: Color.white,
  borderRadius: "100px",
  width: "200px",

  ":hover": {
    backgroundColor: Color.darkPurple,
  },
});

export const CloseButton = styling("button")({
  background: "none",
  border: "none",

  width: "24px",
  height: "24px",

  padding: "0",

  "&:hover": {
    cursor: "pointer",
  },
});

export const FormControlLabelStyled = styling(FormControlLabel)({
  marginTop: "10px",
  "& .MuiFormControlLabel-label": {
    fontSize: "0.875rem",
    color: "rgba(0, 0, 0, 0.87)",
  },
});

export const CheckboxStyled = styling(Checkbox)({});

export const CloseRoundedIconStyled = styling(CloseRoundedIcon)({
  width: "24px",
  height: "24px",
});

export const SGCountryFlag = styling(SGFlag)({
  width: "auto",
  height: "24px",
  margin: "0 0 -5px 8px",
  objectFit: "contain",
});
